import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { ProjectItem } from ".";
import { ButtonBase } from "../../../common/components/form";
import { useReduxAccount } from "../../hooks";
import * as API from "../../lib/api.js";
import * as Links from "../../lib/links.js";
import Confirm from "../Confirm";
import Wait from "../Wait";

export default function ProjectList() {
    const { t } = useTranslation();

    const history = useHistory();
    const { id_plan: selectedPlan } = useReduxAccount();

    const [GTC, setGTC] = React.useState([]);

    const [loading, setLoading] = React.useState(true);
    const [wait, setWait] = React.useState(false);
    // const [accountLimits, setAccountLimits] = React.useState({});
    const [projects, setProjects] = React.useState([]);
    const [canConversion, setCanConverion] = React.useState(null);

    const [websitesLimitCount, setWebsitesLimitCount] = React.useState(null);
    const [websitesLimitShow, setWebsitesLimitShow] = React.useState(false);

    React.useEffect(() => {
        // loadAccountLimits();
        loadProjectList();
        loadPlanList();
        loadGTC();
    }, []);

    // function loadAccountLimits() {
    //     API.AccountLimits().then(response => {
    //         console.info(response);
    //     });
    // }

    function loadProjectList() {
        const _upd_ = Date.now();

        setLoading(true);
        API.ProjectList({ field: "updated", order: "desc" })
            .then(({ projects }) => setProjects((projects || []).map(p => ({ ...p, _upd_ }))))
            .finally(() => {
                setLoading(false);
                setWait(false);
            });

        API.ProjectCanConversion().then(res => {
            setCanConverion(!!res?.canConversion);
        });
    }

    function loadPlanList() {
        API.PlanList().then(({ list }) => {
            const [plan] = list.filter(plan => plan.id === selectedPlan);
            const { websites } = plan.parameters;
            setWebsitesLimitCount(websites);

            if (!plan) {
                setWait(false);
                return;
            }
        });
    }

    function loadGTC() {
        API.GoogleGetTargetConstants().then(({ list }) => setGTC(list));
    }

    function onAddWebsiteClick() {
        setWait(true);
        API.AddWebsiteCheck()
            .then(res => {
                if (!res?.ok) {
                    throw new Error(res?.errors?.[0]);
                }

                if (!res.allow) {
                    setWait(false);
                    setWebsitesLimitShow(true);
                    return;
                }

                return API.WizardClear().then(() => history.push(Links.WebsiteNew()));
            })
            .catch(e => {
                console.warn(e);
                setWait(false);
            });
    }

    function onGoToSubscriptionClick() {
        history.push(Links.Subscription());
    }

    function onCancelClick() {
        setWebsitesLimitShow(false);
    }

    const allLoaded = !loading;
    const projectProps = { loadProjectList, setWait, setLoading, canConversion, GTC, allLoaded };

    return (
        <>
            <div className="panel-projects">
                <h2 className="projects-header">
                    {t("YourWebsites")} {projects.length}
                    {"/"}
                    {websitesLimitCount}
                </h2>

                {loading && projects.length === 0 && <h2 className="panel-heading-text">{t("Loading")}...</h2>}

                <div className="projects-list">
                    {!loading && projects.length === 0 && (
                        <h3 className="panel-heading-text">{t("YouDontHaveWebsites")}</h3>
                    )}

                    {projects.map(project => (
                        <ProjectItem key={project.id} data={project} {...projectProps} />
                    ))}
                </div>

                <div className="projects-actions">
                    <ButtonBase onClick={() => onAddWebsiteClick()} disabled={loading}>
                        {t("PlusAddAWebsite")}
                    </ButtonBase>
                </div>
            </div>

            <Confirm
                show={websitesLimitShow}
                header={t("WebsitesLimitHeader")}
                text={t("WebsitesLimitText")}
                actions={[
                    { onClick: onCancelClick, text: t("Cancel") },
                    {
                        onClick: onGoToSubscriptionClick,
                        text: t("Subscription"),
                        props: { invert: true },
                    },
                ]}
            />

            <Wait show={wait} />
        </>
    );
}
